import React from 'react';

import ManagedFormGroup from 'components/form/managed_input/form_group';

import type { InputProps } from './types';

export default function Address2Input({ options, value, onChange }: InputProps) {
  if (options.address2?.show === false) {
    return null;
  }

  return (
    <ManagedFormGroup
      hasError={options.address2?.hasError}
      label="Address 2"
      required={options.address2?.required}
      value={value.address2}
      onValueChange={address2 => onChange({ ...value, address2 })}
    />
  );
}
